/**
 * Elimina caracteres de control ASCII (0x00-0x1F, 0x7F) de strings de forma recursiva.
 *
 * Útil para limpiar datos de usuario antes de persistirlos en cookies o headers HTTP,
 * evitando que saltos de línea u otros caracteres no imprimibles corrompan el valor.
 *
 * @param {*} value - Valor a sanitizar (string, array, object o cualquier otro tipo)
 * @returns {*} Valor sanitizado con los mismos tipos que la entrada
 */
export function sanitizeControlChars(value) {
  if (typeof value === 'string') {
    // eslint-disable-next-line no-control-regex
    return value.replace(/[\x00-\x1F\x7F]/g, '').trim()
  }

  if (Array.isArray(value)) {
    return value.map(item => sanitizeControlChars(item))
  }

  if (value !== null && typeof value === 'object') {
    const sanitized = {}
    for (const key of Object.keys(value)) {
      sanitized[key] = sanitizeControlChars(value[key])
    }
    return sanitized
  }

  return value
}
